<template>
    <div>
        <v-select :multiple="true" :options="optionsTiendas" :placeholder="'Selecciona '+placeholderm"
                  v-model="selectedTiendas" @input="setCambio"></v-select>
    </div>
</template>

<script>
export default {
    name: "tiendas",
    props:{
        placeholderm:String,
    },
    data(){
        return{
            selectedTiendas:[],
            optionsTiendas:[],
            formatos:[]
        }
    },
    mounted() {
        this.getTiendas();
    },
    methods:{
        getTiendas(){ let $this = this;
            axios
                .post('/api/AdminCatalogos/tiendasSelectD',{formatos:this.formatos})
                .then(function (r){
                    $this.optionsTiendas = r.data;
                });
        },
        setCambio(){
            this.$emit('cambioTienda');
        }
    }
}
</script>

<style scoped>

</style>
